var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPodcastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 138,
    viewBox: "0 0 96 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.9394 41.4579C60.2131 42.1842 59.7773 43.172 59.7773 44.276C59.7773 46.484 61.564 48.2562 63.772 48.2562H73.6644V70.5686C73.6644 84.8043 62.116 96.3527 47.8803 96.3527C33.6446 96.3527 22.0962 84.8043 22.0962 70.5686V48.2562H31.9886C34.1966 48.2562 35.9833 46.484 35.9833 44.276C35.9833 43.172 35.5475 42.1842 34.8212 41.4579C34.0949 40.7316 33.0926 40.2958 31.9886 40.2958H22.0962V30.2437H31.9886C34.1966 30.2437 35.9833 28.4714 35.9833 26.2635C35.9833 25.1595 35.5475 24.1717 34.8212 23.4454C34.0949 22.7191 33.0926 22.2833 31.9886 22.2833H22.3431C24.0427 9.70353 34.8358 0 47.8803 0C54.9982 0 61.4479 2.87617 66.0962 7.53913C69.9892 11.4322 72.6476 16.56 73.4175 22.2833H63.772C62.668 22.2833 61.6657 22.7191 60.9394 23.4454C60.2131 24.1717 59.7773 25.1595 59.7773 26.2635C59.7773 28.4714 61.564 30.2437 63.772 30.2437H73.6644V40.2958H63.772C62.668 40.2958 61.6657 40.7316 60.9394 41.4579Z",
    fill: "url(#paint0_linear_203_606)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7609 57.4592C95.7609 59.5409 94.0713 61.2305 91.9896 61.2305H89.5006V70.5682C89.5006 92.2457 72.8464 110.107 51.6517 112.007V124.196C51.6517 124.196 51.6517 124.197 51.6517 124.197H63.9612C65.3642 124.197 66.6615 124.996 67.28 126.264L70.4479 132.645C71.6698 135.104 69.8747 138 67.114 138H28.6468C25.8861 138 24.091 135.104 25.3129 132.645L28.4808 126.264C29.0993 124.996 30.3966 124.197 31.7996 124.197H44.1091C44.1091 124.197 44.1091 124.196 44.1091 124.196V112.007C22.9144 110.107 6.2603 92.2457 6.2603 70.5682V61.2305H3.7713C1.68953 61.2305 0 59.5409 0 57.4592C0 55.3774 1.68953 53.6879 3.7713 53.6879H10.0316C12.1134 53.6879 13.8029 55.3774 13.8029 57.4592V70.5682C13.8029 89.355 29.0841 104.63 47.8523 104.646L47.8804 104.646L47.9086 104.646C66.6768 104.63 81.958 89.355 81.958 70.5682V57.4592C81.958 55.3774 83.6475 53.6879 85.7293 53.6879H91.9896C94.0713 53.6879 95.7609 55.3774 95.7609 57.4592Z",
    fill: "url(#paint1_linear_203_606)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_606",
    x1: -31.916,
    y1: 201.434,
    x2: 120.046,
    y2: 158.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F87F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F05A5A",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EB426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_203_606",
    x1: 2.67411,
    y1: 138,
    x2: 132.362,
    y2: 65.4504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD01",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F87F39",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F05A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EB426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcastIcon);
export default __webpack_public_path__ + "static/media/podcast-icon.0ffb2fbd930293cd6ae24bd753f32097.svg";
export { ForwardRef as ReactComponent };